// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-people {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  color: var(--dp-text, #f8fafc);
  font-family: inherit;
}

.dp-people__list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.75rem 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.dp-people__section-title {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--dp-accent, #0a8cd8);
  margin-bottom: 0.45rem;
}

.dp-people__section-hint {
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
  color: var(--dp-muted, #94a3b8);
  font-size: 0.72rem;
}

.dp-people__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.75rem;
  margin: 0 0 0.4rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: rgba(30, 41, 59, 0.55);
  color: inherit;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.dp-people__row:hover {
  background: rgba(30, 41, 59, 0.85);
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 40%, transparent);
}

.dp-people__row-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.dp-people__row-name {
  font-size: 0.95rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.dp-people__row-meta {
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
}

.dp-people__present {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #4ade80;
  background: rgba(74, 222, 128, 0.12);
  border-radius: 999px;
  padding: 0.12rem 0.45rem;
}

.dp-people__connected {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.35rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #22c55e;
  background: rgba(34, 197, 94, 0.14);
  border-radius: 999px;
  padding: 0.1rem 0.45rem 0.1rem 0.35rem;
  vertical-align: middle;
}

.dp-people__connected::before {
  content: "";
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.2);
}

.dp-people__row.is-connected {
  border-color: color-mix(in srgb, #22c55e 40%, transparent);
}

.dp-people__thread-name .dp-people__connected {
  margin-left: 0.45rem;
}

.dp-people__badge {
  flex-shrink: 0;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #ff4a5a;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dp-people__empty,
.dp-people__error {
  margin: auto;
  padding: 1.5rem 1rem;
  text-align: center;
  color: var(--dp-muted, #94a3b8);
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  max-width: 280px;
}

.dp-people__error {
  color: #fca5a5;
  max-width: none;
}

.dp-people__thread-bar {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.65rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.4);
  flex-shrink: 0;
}

.dp-people__thread-title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.dp-people__thread-name {
  font-size: 0.95rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-people__history {
  gap: 0.75rem;
}

.dp-people__msg {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  max-width: 92%;
}

.dp-people__msg--mine {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.dp-people__msg--theirs {
  align-self: flex-start;
}

.dp-people__bubble {
  padding: 0.65rem 0.85rem;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(30, 41, 59, 0.88);
  font-size: 0.92rem;
  line-height: 1.45;
}

.dp-people__msg--mine .dp-people__bubble {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--dp-primary, #0877bc) 72%, #0f172a),
    color-mix(in srgb, var(--dp-primary-dark, #065a8f) 85%, #0b0f19)
  );
}

.dp-people__text {
  white-space: pre-wrap;
  word-break: break-word;
}

.dp-people__input {
  min-height: 44px;
  max-height: 44px;
  resize: none;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}

.dp-people__player-block {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.35rem;
}

.dp-people__row--smart {
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 35%, transparent);
}

.dp-people__row--pending {
  border-color: color-mix(in srgb, #f59e0b 45%, transparent);
}

.dp-people__smart-tag {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  padding: 0.12rem 0.35rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 25%, transparent);
  color: var(--dp-accent, #7dd3fc);
}

.dp-people__row-meta--presence {
  opacity: 0.85;
}

.dp-people__smart-letters {
  display: flex;
  gap: 0.25rem;
  margin-top: 0.25rem;
}

.dp-people__row-badges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.dp-people__badge--smart {
  border: none;
  cursor: pointer;
  background: color-mix(in srgb, #f59e0b 75%, #0f172a);
  color: #0f172a;
  font-weight: 800;
}

.dp-people--thread {
  overflow: hidden;
}

.dp-people--player-smart .dp-people__smart-scroll {
  flex: 1 1 auto;
  max-height: none;
}

.dp-people--player-smart .dp-people__history.is-empty {
  display: none;
}

.dp-people--player-smart .dp-people__history:not(.is-empty) {
  flex: 0 1 28%;
  max-height: 28vh;
}

.dp-people__thread-msg {
  margin-left: auto;
  flex-shrink: 0;
  border: 1px solid color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);
  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 18%, transparent);
  color: #e0f2fe;
  border-radius: 999px;
  padding: 0.35rem 0.7rem;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
}

.dp-people__section-lead {
  margin: 0 0 0.55rem;
  font-size: 0.74rem;
  line-height: 1.35;
  color: var(--dp-muted, #94a3b8);
}

.dp-people__group-block {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.4rem;
}

.dp-people__row.is-selected,
.dp-people__group-block.is-selected .dp-people__row {
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 70%, transparent);
  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 16%, rgba(30, 41, 59, 0.85));
}

.dp-people__group-message {
  align-self: stretch;
  border: none;
  border-radius: 12px;
  padding: 0.65rem 0.85rem;
  font-weight: 800;
  font-size: 0.85rem;
  cursor: pointer;
  font-family: inherit;
  background: var(--dp-accent, #0a8cd8);
  color: #0b1220;
}

.dp-people__season-result {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin: 0 0 0.75rem;
  padding: 0.7rem 0.8rem;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(8, 119, 188, 0.28), rgba(15, 23, 42, 0.55));
  border: 1px solid rgba(125, 211, 252, 0.35);
}

.dp-people__season-kicker {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.dp-people__season-value {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #f8fafc;
}

.dp-people__letter-sheet {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 0.85rem 0.9rem 0.95rem;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.18);
}

.dp-people__letter-sheet.is-pending {
  border-color: rgba(251, 191, 36, 0.5);
}

.dp-people__letter-head {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.dp-people__letter-glyph {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.1rem;
  background: rgba(8, 119, 188, 0.28);
  color: #7dd3fc;
}

.dp-people__letter-head strong {
  display: block;
  font-size: 0.92rem;
  color: #f8fafc;
}

.dp-people__letter-state {
  display: block;
  margin-top: 0.12rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: #94a3b8;
}

.dp-people__letter-state.is-complete {
  color: #4ade80;
}
.dp-people__letter-state.is-partial,
.dp-people__letter-state.is-pending {
  color: #fbbf24;
}

.dp-people__letter-copy {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.4;
  color: #cbd5e1;
}

.dp-people__letter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.dp-smart-grid__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fbbf24;
}

.dp-people .dp-smart-grid__cell {
  background: rgba(30, 41, 59, 0.8);
  border-color: rgba(148, 163, 184, 0.2);
  color: #e2e8f0;
}

.dp-people .dp-smart-grid__cell.is-complete {
  border-color: rgba(74, 222, 128, 0.45);
}

.dp-people .dp-smart-grid__cell.is-partial,
.dp-people .dp-smart-grid__cell.is-pending {
  border-color: rgba(251, 191, 36, 0.55);
}

.dp-people .dp-smart-grid__cell.is-active {
  border-color: #38bdf8;
  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.35);
}

.dp-people .dp-smart-grid__letter {
  font-size: 1.15rem;
  font-weight: 800;
  color: #f8fafc;
}

.dp-people__smart-scroll {
  flex: 0 1 auto;
  max-height: min(58vh, 30rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  min-height: 0;
  padding: 0.65rem 0.75rem 0.35rem;
}

.dp-people__smart-event.is-active {
  border-radius: 10px;
  padding: 0.2rem 0.35rem;
  background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.4);
}

.dp-people__smart-summary-banner.is-pending,
.dp-people__s-exercise-card.is-pending {
  border-color: rgba(251, 191, 36, 0.45);
  box-shadow: inset 0 0 0 1px rgba(251, 191, 36, 0.2);
}

.dp-people__smart-summary-banner strong {
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fde68a;
}

.dp-people__dim-facts {
  margin: 0.35rem 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  font-size: 0.78rem;
  color: #e2e8f0;
}

.dp-people__dim-facts li {
  display: grid;
  grid-template-columns: minmax(5.2rem, auto) 1fr;
  gap: 0.45rem;
  align-items: baseline;
}

.dp-people__dim-facts li.is-value-only {
  grid-template-columns: 1fr;
}

.dp-people__smart-review {
  margin: 0.35rem 0.15rem 0.55rem;
  padding: 0.65rem 0.75rem;
  border-radius: 12px;
  border: 1px solid rgba(245, 158, 11, 0.35);
  background: rgba(15, 23, 42, 0.75);
}

.dp-people__smart-review-title {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fbbf24;
  margin-bottom: 0.45rem;
}

.dp-people__smart-event {
  margin-bottom: 0.4rem;
}

.dp-people__smart-event-main {
  width: 100%;
  display: flex;
  gap: 0.55rem;
  align-items: flex-start;
  border: none;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  padding: 0.25rem 0;
  font-family: inherit;
}

.dp-people__smart-event-copy {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.dp-people__smart-event-copy strong {
  font-size: 0.82rem;
}

.dp-people__smart-event-copy span {
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
  white-space: pre-wrap;
}

.dp-people__smart-event-actions {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.35rem;
}

.dp-people__smart-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.dp-people__smart-summary-banner {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.55rem 0.9rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
  background: rgba(15, 23, 42, 0.55);
}

.dp-people__smart-trail {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.45);
  padding: 0.45rem 0.65rem 0.55rem;
}

.dp-people__smart-trail .digiping-smart-rail {
  margin-bottom: 0.35rem;
}

.dp-people__ranking-slip {
  margin: 0.55rem 0 0.35rem;
}

.dp-people__ranking-slip .fltt-slip {
  padding: 12px;
  gap: 10px;
  border-radius: 14px;
}

.dp-people__ranking-slip .fltt-chart {
  min-height: 160px;
}

.dp-people__ranking-slip .fltt-chart__canvas {
  min-height: 180px;
}

.dp-people__s-exercise-card {
  margin: 0.35rem 0.25rem 0.15rem;
  padding: 0.55rem 0.65rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 41, 59, 0.65);
}

.dp-people__s-exercise-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.72rem;
  margin-bottom: 0.25rem;
}

.dp-people__goal-ex {
  margin-top: 0.45rem;
  padding-top: 0.4rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.dp-people__goal-ex:first-of-type {
  margin-top: 0.15rem;
  padding-top: 0;
  border-top: none;
}

.dp-people__goal-ex-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0.9;
  margin-bottom: 0.15rem;
}

.dp-people__s-ex-status {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 0.15rem 0.4rem;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.25);
}

.dp-people__s-ex-status.is-assigned {
  background: rgba(34, 197, 94, 0.25);
  color: #86efac;
}

.dp-people__s-ex-status.is-pending_coach,
.dp-people__s-ex-status.is-proposed {
  background: rgba(251, 191, 36, 0.22);
  color: #fde68a;
}

.dp-people__s-exercise-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 650;
  color: var(--dp-text, #f8fafc);
}

.dp-people__s-exercise-summary {
  margin: 0.25rem 0 0;
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
  white-space: pre-wrap;
}

.dp-people__system-msg {
  font-style: italic;
  color: var(--dp-accent, #0a8cd8);
  font-size: 0.8rem;
}

.dp-teams {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.75rem 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.dp-teams__controls {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  align-items: center;
}

.dp-teams__count {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.75rem;
  color: var(--dp-muted, #94a3b8);
}

.dp-teams__count input {
  width: 3.5rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.7);
  color: inherit;
  padding: 0.25rem 0.4rem;
}

.dp-teams__block h4 {
  margin: 0 0 0.4rem;
  font-size: 0.85rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.dp-teams__block h4 span {
  font-weight: 600;
  color: var(--dp-muted, #94a3b8);
  font-size: 0.72rem;
}

.dp-teams__player {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.55rem 0.65rem;
  margin-bottom: 0.4rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(30, 41, 59, 0.55);
}

.dp-teams__player-main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  background: transparent;
  border: 0;
  color: inherit;
  text-align: left;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}

.dp-teams__player-main span {
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
}

.dp-teams__player-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/AICoach/DigipingPeopleChat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC,4EAA4E;AAC9E;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,oBAAoB;EACpB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kDAAkD;EAClD,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oDAAoD;EACpD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gFAAgF;EAChF,0EAA0E;EAC1E,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,4EAA4E;EAC5E,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,oFAAoF;EACpF,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;;EAEE,sCAAsC;EACtC,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kDAAkD;EAClD,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;EAClD,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb","sourcesContent":[".dp-people {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  color: var(--dp-text, #f8fafc);\n  font-family: inherit;\n}\n\n.dp-people__list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.75rem 1rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.dp-people__section-title {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--dp-accent, #0a8cd8);\n  margin-bottom: 0.45rem;\n}\n\n.dp-people__section-hint {\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  color: var(--dp-muted, #94a3b8);\n  font-size: 0.72rem;\n}\n\n.dp-people__row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.7rem 0.75rem;\n  margin: 0 0 0.4rem;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  background: rgba(30, 41, 59, 0.55);\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.dp-people__row:hover {\n  background: rgba(30, 41, 59, 0.85);\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 40%, transparent);\n}\n\n.dp-people__row-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.dp-people__row-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.dp-people__row-meta {\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.dp-people__present {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #4ade80;\n  background: rgba(74, 222, 128, 0.12);\n  border-radius: 999px;\n  padding: 0.12rem 0.45rem;\n}\n\n.dp-people__connected {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-left: 0.35rem;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.14);\n  border-radius: 999px;\n  padding: 0.1rem 0.45rem 0.1rem 0.35rem;\n  vertical-align: middle;\n}\n\n.dp-people__connected::before {\n  content: \"\";\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 50%;\n  background: #22c55e;\n  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.2);\n}\n\n.dp-people__row.is-connected {\n  border-color: color-mix(in srgb, #22c55e 40%, transparent);\n}\n\n.dp-people__thread-name .dp-people__connected {\n  margin-left: 0.45rem;\n}\n\n.dp-people__badge {\n  flex-shrink: 0;\n  min-width: 1.35rem;\n  height: 1.35rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: #ff4a5a;\n  color: #fff;\n  font-size: 0.68rem;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dp-people__empty,\n.dp-people__error {\n  margin: auto;\n  padding: 1.5rem 1rem;\n  text-align: center;\n  color: var(--dp-muted, #94a3b8);\n  font-size: 0.9rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  max-width: 280px;\n}\n\n.dp-people__error {\n  color: #fca5a5;\n  max-width: none;\n}\n\n.dp-people__thread-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.45rem 0.65rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.4);\n  flex-shrink: 0;\n}\n\n.dp-people__thread-title {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.dp-people__thread-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-people__history {\n  gap: 0.75rem;\n}\n\n.dp-people__msg {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  max-width: 92%;\n}\n\n.dp-people__msg--mine {\n  align-self: flex-end;\n  flex-direction: row-reverse;\n}\n\n.dp-people__msg--theirs {\n  align-self: flex-start;\n}\n\n.dp-people__bubble {\n  padding: 0.65rem 0.85rem;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(30, 41, 59, 0.88);\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.dp-people__msg--mine .dp-people__bubble {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--dp-primary, #0877bc) 72%, #0f172a),\n    color-mix(in srgb, var(--dp-primary-dark, #065a8f) 85%, #0b0f19)\n  );\n}\n\n.dp-people__text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.dp-people__input {\n  min-height: 44px;\n  max-height: 44px;\n  resize: none;\n  padding-top: 0.7rem;\n  padding-bottom: 0.7rem;\n}\n\n.dp-people__player-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 0.35rem;\n}\n\n.dp-people__row--smart {\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 35%, transparent);\n}\n\n.dp-people__row--pending {\n  border-color: color-mix(in srgb, #f59e0b 45%, transparent);\n}\n\n.dp-people__smart-tag {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  padding: 0.12rem 0.35rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 25%, transparent);\n  color: var(--dp-accent, #7dd3fc);\n}\n\n.dp-people__row-meta--presence {\n  opacity: 0.85;\n}\n\n.dp-people__smart-letters {\n  display: flex;\n  gap: 0.25rem;\n  margin-top: 0.25rem;\n}\n\n.dp-people__row-badges {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.25rem;\n}\n\n.dp-people__badge--smart {\n  border: none;\n  cursor: pointer;\n  background: color-mix(in srgb, #f59e0b 75%, #0f172a);\n  color: #0f172a;\n  font-weight: 800;\n}\n\n.dp-people--thread {\n  overflow: hidden;\n}\n\n.dp-people--player-smart .dp-people__smart-scroll {\n  flex: 1 1 auto;\n  max-height: none;\n}\n\n.dp-people--player-smart .dp-people__history.is-empty {\n  display: none;\n}\n\n.dp-people--player-smart .dp-people__history:not(.is-empty) {\n  flex: 0 1 28%;\n  max-height: 28vh;\n}\n\n.dp-people__thread-msg {\n  margin-left: auto;\n  flex-shrink: 0;\n  border: 1px solid color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);\n  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 18%, transparent);\n  color: #e0f2fe;\n  border-radius: 999px;\n  padding: 0.35rem 0.7rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.dp-people__section-lead {\n  margin: 0 0 0.55rem;\n  font-size: 0.74rem;\n  line-height: 1.35;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.dp-people__group-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 0.4rem;\n}\n\n.dp-people__row.is-selected,\n.dp-people__group-block.is-selected .dp-people__row {\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 70%, transparent);\n  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 16%, rgba(30, 41, 59, 0.85));\n}\n\n.dp-people__group-message {\n  align-self: stretch;\n  border: none;\n  border-radius: 12px;\n  padding: 0.65rem 0.85rem;\n  font-weight: 800;\n  font-size: 0.85rem;\n  cursor: pointer;\n  font-family: inherit;\n  background: var(--dp-accent, #0a8cd8);\n  color: #0b1220;\n}\n\n.dp-people__season-result {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  margin: 0 0 0.75rem;\n  padding: 0.7rem 0.8rem;\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(8, 119, 188, 0.28), rgba(15, 23, 42, 0.55));\n  border: 1px solid rgba(125, 211, 252, 0.35);\n}\n\n.dp-people__season-kicker {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.dp-people__season-value {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #f8fafc;\n}\n\n.dp-people__letter-sheet {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  padding: 0.85rem 0.9rem 0.95rem;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n\n.dp-people__letter-sheet.is-pending {\n  border-color: rgba(251, 191, 36, 0.5);\n}\n\n.dp-people__letter-head {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n\n.dp-people__letter-glyph {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 1.1rem;\n  background: rgba(8, 119, 188, 0.28);\n  color: #7dd3fc;\n}\n\n.dp-people__letter-head strong {\n  display: block;\n  font-size: 0.92rem;\n  color: #f8fafc;\n}\n\n.dp-people__letter-state {\n  display: block;\n  margin-top: 0.12rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #94a3b8;\n}\n\n.dp-people__letter-state.is-complete {\n  color: #4ade80;\n}\n.dp-people__letter-state.is-partial,\n.dp-people__letter-state.is-pending {\n  color: #fbbf24;\n}\n\n.dp-people__letter-copy {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.4;\n  color: #cbd5e1;\n}\n\n.dp-people__letter-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.dp-smart-grid__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #fbbf24;\n}\n\n.dp-people .dp-smart-grid__cell {\n  background: rgba(30, 41, 59, 0.8);\n  border-color: rgba(148, 163, 184, 0.2);\n  color: #e2e8f0;\n}\n\n.dp-people .dp-smart-grid__cell.is-complete {\n  border-color: rgba(74, 222, 128, 0.45);\n}\n\n.dp-people .dp-smart-grid__cell.is-partial,\n.dp-people .dp-smart-grid__cell.is-pending {\n  border-color: rgba(251, 191, 36, 0.55);\n}\n\n.dp-people .dp-smart-grid__cell.is-active {\n  border-color: #38bdf8;\n  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.35);\n}\n\n.dp-people .dp-smart-grid__letter {\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: #f8fafc;\n}\n\n.dp-people__smart-scroll {\n  flex: 0 1 auto;\n  max-height: min(58vh, 30rem);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  min-height: 0;\n  padding: 0.65rem 0.75rem 0.35rem;\n}\n\n.dp-people__smart-event.is-active {\n  border-radius: 10px;\n  padding: 0.2rem 0.35rem;\n  background: rgba(251, 191, 36, 0.12);\n  border: 1px solid rgba(251, 191, 36, 0.4);\n}\n\n.dp-people__smart-summary-banner.is-pending,\n.dp-people__s-exercise-card.is-pending {\n  border-color: rgba(251, 191, 36, 0.45);\n  box-shadow: inset 0 0 0 1px rgba(251, 191, 36, 0.2);\n}\n\n.dp-people__smart-summary-banner strong {\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fde68a;\n}\n\n.dp-people__dim-facts {\n  margin: 0.35rem 0 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  font-size: 0.78rem;\n  color: #e2e8f0;\n}\n\n.dp-people__dim-facts li {\n  display: grid;\n  grid-template-columns: minmax(5.2rem, auto) 1fr;\n  gap: 0.45rem;\n  align-items: baseline;\n}\n\n.dp-people__dim-facts li.is-value-only {\n  grid-template-columns: 1fr;\n}\n\n.dp-people__smart-review {\n  margin: 0.35rem 0.15rem 0.55rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  background: rgba(15, 23, 42, 0.75);\n}\n\n.dp-people__smart-review-title {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #fbbf24;\n  margin-bottom: 0.45rem;\n}\n\n.dp-people__smart-event {\n  margin-bottom: 0.4rem;\n}\n\n.dp-people__smart-event-main {\n  width: 100%;\n  display: flex;\n  gap: 0.55rem;\n  align-items: flex-start;\n  border: none;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  padding: 0.25rem 0;\n  font-family: inherit;\n}\n\n.dp-people__smart-event-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.dp-people__smart-event-copy strong {\n  font-size: 0.82rem;\n}\n\n.dp-people__smart-event-copy span {\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n  white-space: pre-wrap;\n}\n\n.dp-people__smart-event-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.35rem;\n}\n\n.dp-people__smart-btns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.dp-people__smart-summary-banner {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.55rem 0.9rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n  background: rgba(15, 23, 42, 0.55);\n}\n\n.dp-people__smart-trail {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.45);\n  padding: 0.45rem 0.65rem 0.55rem;\n}\n\n.dp-people__smart-trail .digiping-smart-rail {\n  margin-bottom: 0.35rem;\n}\n\n.dp-people__ranking-slip {\n  margin: 0.55rem 0 0.35rem;\n}\n\n.dp-people__ranking-slip .fltt-slip {\n  padding: 12px;\n  gap: 10px;\n  border-radius: 14px;\n}\n\n.dp-people__ranking-slip .fltt-chart {\n  min-height: 160px;\n}\n\n.dp-people__ranking-slip .fltt-chart__canvas {\n  min-height: 180px;\n}\n\n.dp-people__s-exercise-card {\n  margin: 0.35rem 0.25rem 0.15rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(30, 41, 59, 0.65);\n}\n\n.dp-people__s-exercise-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  font-size: 0.72rem;\n  margin-bottom: 0.25rem;\n}\n\n.dp-people__goal-ex {\n  margin-top: 0.45rem;\n  padding-top: 0.4rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.dp-people__goal-ex:first-of-type {\n  margin-top: 0.15rem;\n  padding-top: 0;\n  border-top: none;\n}\n\n.dp-people__goal-ex-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  opacity: 0.9;\n  margin-bottom: 0.15rem;\n}\n\n.dp-people__s-ex-status {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 0.15rem 0.4rem;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.25);\n}\n\n.dp-people__s-ex-status.is-assigned {\n  background: rgba(34, 197, 94, 0.25);\n  color: #86efac;\n}\n\n.dp-people__s-ex-status.is-pending_coach,\n.dp-people__s-ex-status.is-proposed {\n  background: rgba(251, 191, 36, 0.22);\n  color: #fde68a;\n}\n\n.dp-people__s-exercise-title {\n  margin: 0;\n  font-size: 0.85rem;\n  font-weight: 650;\n  color: var(--dp-text, #f8fafc);\n}\n\n.dp-people__s-exercise-summary {\n  margin: 0.25rem 0 0;\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n  white-space: pre-wrap;\n}\n\n.dp-people__system-msg {\n  font-style: italic;\n  color: var(--dp-accent, #0a8cd8);\n  font-size: 0.8rem;\n}\n\n.dp-teams {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.75rem 1rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.dp-teams__controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  align-items: center;\n}\n\n.dp-teams__count {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.75rem;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.dp-teams__count input {\n  width: 3.5rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.7);\n  color: inherit;\n  padding: 0.25rem 0.4rem;\n}\n\n.dp-teams__block h4 {\n  margin: 0 0 0.4rem;\n  font-size: 0.85rem;\n  display: flex;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.dp-teams__block h4 span {\n  font-weight: 600;\n  color: var(--dp-muted, #94a3b8);\n  font-size: 0.72rem;\n}\n\n.dp-teams__player {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.55rem 0.65rem;\n  margin-bottom: 0.4rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(30, 41, 59, 0.55);\n}\n\n.dp-teams__player-main {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n  background: transparent;\n  border: 0;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n}\n\n.dp-teams__player-main span {\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.dp-teams__player-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
